"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelected = void 0;
var _react = require("react");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var emptyArray = [];
var useSelected = function useSelected() {
  var selectedGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyArray;
  var selectedStudents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
  var classesMapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var groupsMapper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var studentsMapper = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var onChanged = arguments.length > 5 ? arguments[5] : undefined;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedGroupsIds = _useState2[0],
    setSelectedGroupsIds = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedClassesIds = _useState4[0],
    setSelectedClassesIds = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedStudentsIds = _useState6[0],
    setSelectedStudentsIds = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    originalSelectedGroupsIds = _useState8[0],
    setOriginalSelectedGroupsIds = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    originalSelectedClassesIds = _useState10[0],
    setOriginalSelectedClassesIds = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    originalSelectedStudentsIds = _useState12[0],
    setOriginalSelectedStudentsIds = _useState12[1];
  (0, _react.useEffect)(function () {
    if (selectedGroups) {
      var _selectedClassesIds = selectedGroups.filter(function (group) {
        return group.groupType === 'class';
      }).map(function (group) {
        return group.id;
      });
      setOriginalSelectedClassesIds(_selectedClassesIds);
      setSelectedClassesIds(_selectedClassesIds);
      var _selectedGroupsIds = selectedGroups.filter(function (group) {
        return group.groupType === 'subschool';
      }).map(function (group) {
        return group.id;
      });
      setOriginalSelectedGroupsIds(_selectedGroupsIds);
      setSelectedGroupsIds(_selectedGroupsIds);
    } else {
      setOriginalSelectedClassesIds([]);
      setSelectedClassesIds([]);
      setOriginalSelectedGroupsIds([]);
      setSelectedGroupsIds([]);
    }
  }, [selectedGroups]);
  (0, _react.useEffect)(function () {
    if (selectedStudents) {
      var selectedStudentesIds = selectedStudents.map(function (student) {
        return student.id || student.studentID;
      });
      setSelectedStudentsIds(selectedStudentesIds);
      setOriginalSelectedStudentsIds(selectedStudentesIds);
    } else {
      setOriginalSelectedStudentsIds([]);
      setSelectedStudentsIds([]);
    }
  }, [selectedStudents]);
  var getSelectedGroupsAndStudentsData = function getSelectedGroupsAndStudentsData() {
    return {
      selectedGroups: [].concat(_toConsumableArray(selectedClassesIds === null || selectedClassesIds === void 0 ? void 0 : selectedClassesIds.map(function (c) {
        return classesMapper && classesMapper[c];
      })), _toConsumableArray(selectedGroupsIds === null || selectedGroupsIds === void 0 ? void 0 : selectedGroupsIds.map(function (g) {
        return groupsMapper && groupsMapper[g];
      }))),
      selectedStudents: selectedStudentsIds === null || selectedStudentsIds === void 0 ? void 0 : selectedStudentsIds.map(function (s) {
        return studentsMapper && studentsMapper[s];
      }) //.filter((s: string) => !!s),
    };
  };

  var onSelectedChanged = function onSelectedChanged(newSelectedData) {
    setSelectedGroupsIds(newSelectedData.selectedGroupsIds);
    setSelectedClassesIds(newSelectedData.selectedClassesIds);
    setSelectedStudentsIds(newSelectedData.selectedStudentsIds);
    if (onChanged) {
      var _newSelectedData$sele, _newSelectedData$sele2, _newSelectedData$sele3;
      onChanged({
        selectedGroups: [].concat(_toConsumableArray((_newSelectedData$sele = newSelectedData.selectedClassesIds) === null || _newSelectedData$sele === void 0 ? void 0 : _newSelectedData$sele.map(function (c) {
          return classesMapper && classesMapper[c];
        })), _toConsumableArray((_newSelectedData$sele2 = newSelectedData.selectedGroupsIds) === null || _newSelectedData$sele2 === void 0 ? void 0 : _newSelectedData$sele2.map(function (g) {
          return groupsMapper && groupsMapper[g];
        }))),
        selectedStudents: (_newSelectedData$sele3 = newSelectedData.selectedStudentsIds) === null || _newSelectedData$sele3 === void 0 ? void 0 : _newSelectedData$sele3.map(function (s) {
          return studentsMapper && studentsMapper[s];
        }) //.filter((s) => !!s),
      });
    }
  };

  return {
    setSelectedGroupsIds: setSelectedGroupsIds,
    selectedGroupsIds: selectedGroupsIds,
    selectedClassesIds: selectedClassesIds,
    originalSelectedGroupsIds: originalSelectedGroupsIds,
    originalSelectedClassesIds: originalSelectedClassesIds,
    setSelectedStudentsIds: setSelectedStudentsIds,
    selectedStudentsIds: selectedStudentsIds,
    originalSelectedStudentsIds: originalSelectedStudentsIds,
    getSelectedGroupsAndStudentsData: getSelectedGroupsAndStudentsData,
    onSelectedChanged: onSelectedChanged
  };
};
exports.useSelected = useSelected;